/**
 * Contains some constants which can be used to specify accessbility roles, specifically those which differ between web and native
 */

import { Platform } from 'react-native';

/**
 * Role to attach to a component to represent a `<header>` tag
 */
export const HeaderContainer = Platform.OS === 'web' ? 'banner' : 'header';

/**
 * Role to attach to a component to represent a `<h1..6>` tag
 */
export const HeaderText = Platform.OS === 'web' ? 'heading' : 'text';
